// src/app/error.tsx
"use client";

import { useEffect } from "react";
import logger from "@/utils/logger.client";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    // Sanitize and log error details
    logger.error("App-level error caught by Error component", { message: error.message });
  }, [error]);

  return (
    <div className="p-4 text-red-500">
      <h2>Something went wrong!</h2>
      <p>{error.message}</p>
      <button
        className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
        onClick={() => reset()}
      >
        Try again
      </button>
    </div>
  );
}
